import React, { Component } from 'react'
import API from './../Function/APILink'
import { Link } from 'react-router-dom'

class SidebarDetail extends Component {

    constructor(props) {
        super(props)
        
        this.addcounterview = this.addcounterview.bind(this)
        this.componentDidMount = this.componentDidMount.bind(this)
        this.rendertopcontent = this.rendertopcontent.bind(this)
        this.handlemore = this.handlemore.bind(this)
        this.handleless = this.handleless.bind(this)
        this.state = {
            newestlist: [],
            popularlist: [],
            helpfullist: [],
            newestlistend: 3,
            popularlistend: 3,
            helpfullistend: 3,
            token: 'qwertygf123456'
        }
    }

    async addcounterview(id) {
        window.scrollTo(0,0)

        await API.post("AddCounterView.php?token="+this.state.token+"&id="+id)
        return this.props.refresh()
    }

    async componentDidMount() {
        await API.get("GetTopNewestContent.php?token="+this.state.token)
        .then(response => {
            this.setState({
                newestlist: response.data["RECORD"]
            })
        })
        .catch(error => {
            this.setState({
                newestlist: []
            })
        })

        await API.get("GetTopPopularContent.php?token="+this.state.token)
        .then(response => {
            this.setState({
                popularlist: response.data["RECORD"]
            })
        })
        .catch(error => {
            this.setState({
                popularlist: []
            })
        })

        await API.get("GetTopHelpfulContent.php?token="+this.state.token)
        .then(response => {
            this.setState({
                helpfullist: response.data["RECORD"]
            })
        })
        .catch(error => {
            this.setState({
                helpfullist: []
            })
        })
    }

    handlemore(statename) {
        this.setState({
            [statename]: 10
        })
    }

    handleless(statename) {
        this.setState({
            [statename]: 3
        })
    }

    rendertopcontent(title, list, bgtitle, statename, statevalue){
        return (
            <div className="sidebar-detail-list">
                <div className={`title ${bgtitle}`}>{title}</div>
                {list.slice(0,statevalue).map((content, key) => {
                    return (
                        <div key={key} className="list">
                            <Link 
                                to={`/detail/${encodeURIComponent(content.URL)}`} 
                                onClick={() => this.addcounterview(content.ContentID)}>
                                {content.Title}
                            </Link>
                        </div>
                    )
                })}
                {
                    (statevalue===10) 
                    ? 
                        <div className="list">
                            <span className="more" onClick={() => this.handleless(statename)}>Lihat Sedikitnya</span>
                        </div>
                    :
                        <div className="list">
                            <span className="more" onClick={() => this.handlemore(statename)}>Lihat Selengkapnya</span>
                        </div>
                }
            </div>
        )
    }

    render() {
        const { 
            popularlist, newestlist, helpfullist, 
            newestlistend, popularlistend, helpfullistend
        } = this.state
        return (
            <div className="sidebar-detail">
                {this.rendertopcontent("Artikel Terbaru",newestlist,"gf-bggreen","newestlistend",newestlistend)}
                {this.rendertopcontent("Artikel Terpopuler",popularlist,"gf-bgred","popularlistend",popularlistend)}
                {this.rendertopcontent("Artikel Terbantu",helpfullist,"gf-bgorange","helpfullistend",helpfullistend)}
            </div>
        )
    }
}

export default SidebarDetail